var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43085 1.4491C7.56774 1.30255 7.7627 1.21094 7.97905 1.21094C8.19365 1.21094 8.3872 1.30107 8.52391 1.44554L11.9436 5.0443C12.229 5.34457 12.2169 5.81929 11.9166 6.10462C11.6163 6.38995 11.1416 6.37784 10.8563 6.07757L8.72905 3.83898L8.72905 10.3609C8.72905 10.7752 8.39327 11.1109 7.97905 11.1109C7.56484 11.1109 7.22905 10.7752 7.22905 10.3609L7.22905 3.85584L5.14679 6.07422C4.86331 6.37624 4.38868 6.39126 4.08666 6.10778C3.78465 5.8243 3.76963 5.34966 4.05311 5.04765L7.43085 1.4491ZM2.19995 9.21094C2.61416 9.21094 2.94995 9.54672 2.94995 9.96094L2.94995 11.5609C2.94995 12.2513 3.5096 12.8109 4.19995 12.8109L11.8 12.8109C12.4903 12.8109 13.05 12.2513 13.05 11.5609V9.96094C13.05 9.54672 13.3857 9.21094 13.8 9.21094C14.2142 9.21094 14.55 9.54672 14.55 9.96094V11.5609C14.55 13.0797 13.3187 14.3109 11.8 14.3109L4.19995 14.3109C2.68117 14.3109 1.44995 13.0797 1.44995 11.5609L1.44995 9.96094C1.44995 9.54672 1.78574 9.21094 2.19995 9.21094Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.7efbf975f4f440b11957905059a9295d.svg";
export { ForwardRef as ReactComponent };